<template>
<div class="chapter">
<div class="inner_page">
<p class="right" id="cop"><a id="page8"></a>Copyright</p>
<p class="crt">The Holocaust: The Human Tragedy<br/>Copyright © 1985, 2014 by Martin Gilbert<br/>Cover art, special contents, and Electronic Edition © 2014 by RosettaBooks LLC</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer who may quote brief passages in a review.</p>
<p class="crt">Cover jacket design by David Ter-Avanesyan/Ter33Design<br/>Cover image credit WhiteHaven / Shutterstock.com<br/>ISBN e-Pub edition: 9780795337192</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cop.vue?518d5c52